import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=101d0e76"
import script from "./Office.vue?vue&type=script&lang=js"
export * from "./Office.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports